import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionSetupSubmissionData } from './monthly-pension-setup-submission-data';

export class MonthlyPensionSetupSubmission implements Deserializable {
  public new!: MonthlyPensionSetupSubmissionData;

  public onDeserialize() {
    if (this.new) {
      this.new = window.injector.Deserialize.instanceOf(MonthlyPensionSetupSubmissionData, this.new);
    }
  }
}
